var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "ux-grid",
        {
          ref: "plxTable",
          attrs: {
            data: _vm.tableData,
            "max-height": "500",
            "show-overflow": "tooltip",
            "highlight-current-row": "",
          },
          on: { "selection-change": _vm.selectionChange },
        },
        [
          _c("ux-table-column", {
            attrs: {
              align: "center",
              type: "checkbox",
              width: "80",
              visible: true,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "报告维护频率",
              field: "reportFreqDesc",
              width: "100",
              visible: true,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "报告期限",
              "min-width": "100",
              field: "reportDate",
              visible: true,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.goDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.reportDate))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "Category3",
              field: "category3Name",
              width: "100",
              visible: true,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "Sponsor",
              "min-width": "100",
              field: "sponsorName",
              visible: true,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "ASL Group",
              "min-width": "120",
              field: "aslGroupName",
              visible: true,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "麦当劳农场出栏量(只)",
              "min-width": "160",
              field: "mcdFarmCrapAmount",
              visible: true,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "麦当劳农场出栏量(重量,kg)",
              "min-width": "190",
              field: "mcdFarmCrapWeight",
              visible: true,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "抗生素用量(mg/kg)(原粉量/出栏总重量)",
              "min-width": "280",
              field: "antibioticsUsage",
              visible: true,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "HPCIA类抗生素使用量(mg/kg)(HPCIA抗生素原粉量/出栏总重量)",
              "min-width": "460",
              field: "hpciaAntibioticsUsage",
              visible: true,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "前7日抗生素使用量（mg/kg)",
              "min-width": "200",
              field: "usageIn7Day",
              visible: _vm.showStatus,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "状态",
              "min-width": "80",
              field: "statusI18n",
              visible: true,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "更新人",
              "min-width": "100",
              field: "submitUser",
              visible: true,
            },
          }),
          _c("ux-table-column", {
            attrs: {
              align: "center",
              title: "更新日期",
              "min-width": "120",
              field: "submitDate",
              visible: true,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }